export default __webpack_public_path__ + "static/media/com-mobile.66250bbf.png";